// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLaborRateDealers} from '../../shared/repositories';
import {initializeList} from './dealers-filtered';

export const readDealers = searchFilters =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborRateDealers();

            dispatch({
                data,
                type: actions.SET_LABOR_RATE_DEALERS
            });

            dispatch(initializeList(data, searchFilters));

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/action-creators/get-dealers.js